import React from 'react';
import { IMenuItem } from '../Menu';

export type SelectOption = IMenuItem & {
  value: string | number;
  imgSrc?: string | React.FC<{ className?: string }>;
};
